// extracted by mini-css-extract-plugin
module.exports = {"root":"Tabs_root__2YZL5","tab":"Tabs_tab__1eE3W","tabActive":"Tabs_tabActive__a5LHI"};